import _ from 'lodash'

export const isFavorite = (item, favorites) => _.findIndex(favorites, ({ id }) => _.get(item, 'id') === id) > -1
